var PORTAL_DOM_ID = 'portal-dom-id';
function getPortalDOM(domId) {
    var portalDOM = document.getElementById(domId || PORTAL_DOM_ID);
    if (!portalDOM) {
        portalDOM = document.createElement('div');
        portalDOM.setAttribute('id', domId || PORTAL_DOM_ID);
        document.body.appendChild(portalDOM);
    }
    return portalDOM;
}

export { getPortalDOM };
//# sourceMappingURL=portaldom.util.js.map
